import { render, staticRenderFns } from "./ProposerHistory.vue?vue&type=template&id=2a28a959&scoped=true&"
import script from "./ProposerHistory.vue?vue&type=script&lang=js&"
export * from "./ProposerHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProposerHistory.vue?vue&type=style&index=0&id=2a28a959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28a959",
  null
  
)

export default component.exports